    <div *ngIf="!(dynamicTableData?.result?.list && dynamicTableData?.result?.list?.length > 0) && !isChartDataLoading" class="no-data-container">
        <div class="p-text-center">
            <i class="pi pi-chart-bar" style="font-size: 3rem; color: #ccc; margin-bottom: 1rem;"></i>
            <h3>No Data Found</h3>
            <p *ngIf="filterInColumns && filterInColumns.length > 0">No data is available for this chart with the current filters.</p>
        </div>
    </div>

    <!-- Chart Content -->
    <ng-container  [ngSwitch]="dynamicChart?.type">
    <ng-container *ngSwitchCase="'barChart'">
        <div id="chart-column-{{uniqueId}}"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'lineChart'">
        <div id="chart-line-{{uniqueId}}"></div>
    </ng-container>
    <ng-container *ngSwitchCase="'pieChart'">
        <div id="chart-pie-{{uniqueId}}"></div>
    </ng-container>
<ng-container *ngSwitchCase="'ganttChart'">
    <div class="gantt-chart-scroll-wrapper">
        <div [id]="'chart-gantt-' + uniqueId" class="gantt-chart-container" [style.minWidth.px]="2000">
        </div>
    </div>
</ng-container>
</ng-container>
